import fetch from 'isomorphic-fetch';

export type formData = {
  EMAIL: string;
  OPT_IN: number;
  CONFIRM_EMAIL: boolean;
};

/**
 * Implementation - Brevo Newsletter Subscription Form:
 * https://docs.freitag.de/developers/third-parties/brevo/
 */
export class NewsletterService {
  constructor(
    private readonly url: string,
    private readonly tag: string,
  ) {}

  signUp = async (formData: formData) => {
    const formDataDTO = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      formDataDTO.append(key, value.toString());
    });

    formDataDTO.append('TAG2', this.tag);

    const settings = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: formDataDTO,
    };

    const response = await fetch(this.url, settings);

    if (!response.ok) {
      const msg = await response.text();
      throw new Error(`Status code:${response.status}\nError:${msg}`);
    }

    const res = await response.json();

    return res;
  };
}
